import * as React from 'react';
import { useContext, useMemo } from 'react';
import { withResizeDetector } from 'react-resize-detector';

import { AppNavigatorParamsContext, AppNavigatorPathContext } from './app-navigator.context';
import { Pane, PaneProps } from './Pane';
import { RouteMap } from './utils';

export interface PaneWrapperProps {
  primary?: boolean;
  ErrorComponent?: PaneProps['ErrorComponent'];
}

export const createPane = (name: string, routeConfig: Record<string, React.ComponentType>) => {
  const routes = new RouteMap(routeConfig);

  const PaneComponent = withResizeDetector(class PaneComponent extends Pane {
    static displayName = name;
  });

  const PaneWrapper = ({ primary, ErrorComponent }: PaneWrapperProps) => {
    const path = useContext(AppNavigatorPathContext);
    const params = useContext(AppNavigatorParamsContext);
    const currentRoute = useMemo(() => path && routes.findMatchingRoute(path.asList), [path]);
    const Content = currentRoute && routeConfig[currentRoute];
    const routeParams = useMemo(
      () => Content && routes.getRouteParams(currentRoute, path.asList),
      [path, Content],
    );
    const showMeasurements = !!params && Object.prototype.hasOwnProperty.call(params, 'showMeasurements');

    return React.createElement(
      PaneComponent,
      { Content, routeParams, showMeasurements, primary, ErrorComponent },
    );
  };
  return PaneWrapper;
};
